(() => {
  const SELECTOR = '[data-a26-slider]';

  function bindSlider(rail) {
    if (!rail || rail.dataset.a26SliderReady === 'true') return;
    rail.dataset.a26SliderReady = 'true';

    const section = rail.closest('.a26-athletes, .a26-reviews') || rail.parentElement;
    const previous = section && section.querySelector('[data-a26-slider-prev], [data-a26-prev]');
    const next = section && section.querySelector('[data-a26-slider-next], [data-a26-next]');
    let pointerId = null;
    let pointerStart = 0;
    let scrollStart = 0;
    let dragged = false;

    const step = () => {
      const item = rail.firstElementChild;
      if (!item) return Math.max(rail.clientWidth * .8, 280);
      const style = getComputedStyle(rail);
      return item.getBoundingClientRect().width + (parseFloat(style.columnGap || style.gap) || 0);
    };

    const updateControls = () => {
      if (previous) previous.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };

    const move = (direction) => {
      if (!rail.classList.contains('a26-athletes__rail')) {
        rail.scrollBy({ left: direction * step(), behavior: 'smooth' });
        return;
      }

      const max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const current = rail.scrollLeft;
      const origin = rail.getBoundingClientRect().left;
      const positions = [0, ...[...rail.children].slice(1).map((item) => (
        Math.min(max, Math.max(0, item.getBoundingClientRect().left - origin + current))
      )), max];
      const target = direction > 0
        ? positions.find((position) => position > current + 2) ?? max
        : positions.reverse().find((position) => position < current - 2) ?? 0;

      rail.scrollTo({ left: target, behavior: 'smooth' });
    };

    previous && previous.addEventListener('click', () => move(-1));
    next && next.addEventListener('click', () => move(1));

    rail.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      pointerId = event.pointerId;
      pointerStart = event.clientX;
      scrollStart = rail.scrollLeft;
      dragged = false;
      rail.setPointerCapture(pointerId);
      rail.classList.add('is-dragging');
    });

    rail.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;
      const distance = event.clientX - pointerStart;
      if (Math.abs(distance) > 5) dragged = true;
      rail.scrollLeft = scrollStart - distance;
    });

    const release = (event) => {
      if (pointerId !== event.pointerId) return;
      if (rail.hasPointerCapture(pointerId)) rail.releasePointerCapture(pointerId);
      pointerId = null;
      rail.classList.remove('is-dragging');
    };

    rail.addEventListener('pointerup', release);
    rail.addEventListener('pointercancel', release);
    rail.addEventListener('click', (event) => {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);
    rail.addEventListener('scroll', updateControls, { passive: true });
    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();

    if (section && section.dataset.a26Autoplay === 'true') {
      const delay = Number(section.dataset.a26AutoplayDelay) || 5000;
      let timer;
      const schedule = () => {
        window.clearInterval(timer);
        timer = window.setInterval(() => {
          const atEnd = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
          if (atEnd && section.dataset.a26Loop === 'true') {
            rail.scrollTo({ left: 0, behavior: 'smooth' });
          } else if (!atEnd) {
            move(1);
          }
        }, delay);
      };
      const pause = () => window.clearInterval(timer);
      rail.addEventListener('pointerenter', pause);
      rail.addEventListener('pointerleave', schedule);
      rail.addEventListener('focusin', pause);
      rail.addEventListener('focusout', schedule);
      schedule();
    }
  }

  function bindTraining(section) {
    if (!section || section.dataset.a26TrainingReady === 'true') return;
    section.dataset.a26TrainingReady = 'true';
    const buttons = [...section.querySelectorAll('[data-a26-video-index]')];
    const player = section.querySelector('video[data-a26-player]');
    if (!buttons.length || !player) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        buttons.forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.classList.toggle('active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });

        const source = button.dataset.a26VideoSrc || '';
        const type = button.dataset.a26VideoType || 'video/mp4';
        const poster = button.dataset.a26VideoPoster || '';

        player.pause();
        if (poster) player.poster = poster;
        player.replaceChildren();
        if (source) {
          const sourceElement = document.createElement('source');
          sourceElement.src = source;
          sourceElement.type = type;
          player.appendChild(sourceElement);
        }
        player.load();
      });
    });
  }

  function init(scope = document) {
    scope.querySelectorAll(SELECTOR).forEach(bindSlider);
    scope.querySelectorAll('[data-a26-training]').forEach(bindTraining);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
